import { authorizedAction } from 'api'
import { ErrorProp } from './'
import { UserType } from 'types'

export type DeactivateResponseProps =
  | {
      success: false
      error: ErrorProp
      message?: string
    }
  | {
      success: true
    }

export type DeactivateProps = {
  userId: string
  userType?: UserType
}

export async function deactivate({
  userId,
  userType,
}: DeactivateProps): Promise<DeactivateResponseProps> {
  try {
    const response = await authorizedAction({
      action: 'Student.Deactivate',
      body: {
        Username: userId,
        userType,
      },
    })

    const json = (await response.json()) as DeactivateResponseProps

    if (json.success) {
      return { success: true }
    } else {
      return {
        success: false,
        error: json.error ?? json.message,
      }
    }
  } catch (e: any) {
    throw e
  }
}
